import DetailsRow from "@components/customer/DetailsRow";
import Paragraph from "@vfuk/core-paragraph";
import { useTranslation } from "react-i18next";
import { User } from "src/interfaces/user";

type ViewUserDetailsProps = {
  user: User;
};

const ViewUserDetails = ({ user }: ViewUserDetailsProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "shared:users",
  });
  return (
    <>
      <DetailsRow>
        <div>
          <Paragraph size={2} weight={3} noMargin>
            {t("view_user:name")}
          </Paragraph>
          <Paragraph size={2} weight={2}>
            {user.firstName + " " + user.lastName}
          </Paragraph>
        </div>
        {user.countryCode && user.contactNumber && (
          <div>
            <Paragraph size={2} weight={3} noMargin>
              {t("view_user:contact_number")}
            </Paragraph>
            <Paragraph size={2} weight={2}>
              {user.countryCode + " " + user.contactNumber}
            </Paragraph>
          </div>
        )}

        <div>
          <Paragraph size={2} weight={3} noMargin>
            {t("view_user:email")}
          </Paragraph>
          <Paragraph size={2} weight={2}>
            {user.email}
          </Paragraph>
        </div>
      </DetailsRow>
      <DetailsRow>
        <div>
          <Paragraph size={2} weight={3} noMargin={true}>
            {t("view_user:organisation")}
          </Paragraph>
          <Paragraph size={2} weight={2}>
            {user.organisation && user.organisation.orgName}
          </Paragraph>
        </div>

        <div>
          <Paragraph size={2} weight={3} noMargin={true}>
            {t("view_user:role")}
          </Paragraph>
          <Paragraph size={2} weight={2}>
            {user.role && user.role.roleName}
          </Paragraph>
        </div>
        <div>
          <Paragraph size={2} weight={3} noMargin={true}>
            {t("view_user:status")}
          </Paragraph>
          <Paragraph size={2} weight={2}>
            {user.status.charAt(0).toUpperCase() + user.status.slice(1)}
          </Paragraph>
        </div>
      </DetailsRow>
    </>
  );
};

export default ViewUserDetails;
